import React from 'react';
import { FiMail, FiSettings } from 'react-icons/fi';
import { FaRegFileAlt } from 'react-icons/fa';
import UserProfile from './UserProfile';
import '../styles/Sidebar.css';

function Sidebar({ profileOption, setProfileOption }) {
    return (
        <div className="sidebar d-none d-lg-block">
            <UserProfile />
            <nav className="sidebar-nav">
                <div className={`nav-item ${profileOption === 'dailyreflection' ? 'active' : ''}`} onClick={() => setProfileOption('dailyreflection')}>
                    <FaRegFileAlt className="icon" />
                    Daily Reflection
                </div>
                <div className={`nav-item ${profileOption === 'emailreminder' ? 'active' : ''}`} onClick={() => setProfileOption('emailreminder')}>
                    <FiMail className="icon" />
                    Email Reminder
                </div>
                <div className={`nav-item ${profileOption === 'settings' ? 'active' : ''}`} onClick={() => setProfileOption('settings')}>
                    <FiSettings className="icon" />
                    Settings
                </div>
            </nav>
        </div>
    );
};

export default Sidebar;
